import type { CalendarSettings } from '../api';
export function StaffCalendarAccess({
  value,
  onChange,
}: {
  value: CalendarSettings;
  onChange: (value: CalendarSettings) => void;
}) {
  if (!value.staffOnly) return null;
  return (
    <fieldset>
      <legend>Staff access</legend>
      <div className="form-grid">
        <label className="field">
          <span>Who can access</span>
          <select
            aria-label="Who can access"
            value={value.staffAccess || 'all'}
            onChange={(event) =>
              onChange({ ...value, staffAccess: event.target.value as 'all' | 'selected' })
            }
          >
            <option value="all">All staff in approved domains</option>
            <option value="selected">Selected staff members</option>
          </select>
        </label>
        {(value.staffAccess || 'all') === 'all' && (
          <label className="field">
            <span>Default staff permission</span>
            <select
              aria-label="Default staff permission"
              value={value.staffDefaultRole || 'viewer'}
              onChange={(event) =>
                onChange({ ...value, staffDefaultRole: event.target.value as 'viewer' | 'editor' })
              }
            >
              <option value="viewer">Read-only</option>
              <option value="editor">Can edit</option>
            </select>
          </label>
        )}
      </div>
      <p>
        {value.staffAccess === 'selected'
          ? 'Only added staff members can access this calendar, using their membership role.'
          : 'Eligible staff automatically receive this permission. Individual roles can add permissions, but cannot reduce this default. Calendar management is granted separately.'}
      </p>
    </fieldset>
  );
}
